import { ReactNode } from 'react';

import styles from './suggested-price-icon-tile.module.scss';

interface SuggestedPriceIconTileProps {
  children: ReactNode;
  dataTestId?: string;
}

/**
 * Tinted, rounded icon tile that leads each row in the info drawer's explanation and impact
 * lists. Owns only the tile chrome — the caller supplies the glyph.
 */
export const SuggestedPriceIconTile = ({ children, dataTestId }: SuggestedPriceIconTileProps) => (
  <span aria-hidden className={styles.tile} data-testid={dataTestId}>
    {children}
  </span>
);
